import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { LogOut } from "lucide-react";

const linkBase =
  "overline text-ink-soft hover:text-matcha-dark transition-colors duration-200 py-1";
const linkActive = "text-ink !text-matcha-dark";

export default function StaffLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/staff/login");
  };

  const isAdmin = user?.role === "admin";

  return (
    <div className="min-h-screen bg-cream text-ink">
      <header className="border-b border-ink/10 bg-bone/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-5 flex items-center justify-between gap-6">
          <Link
            to="/staff/dashboard"
            data-testid="staff-nav-logo"
            className="font-display text-ink"
            style={{ letterSpacing: "0.16em", fontSize: "1.05rem" }}
          >
            MATCHA<span className="text-matcha-dark">·</span>STORY
            <span className="ml-3 overline text-ink-soft">/ staff</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <NavLink
              to="/staff/dashboard"
              data-testid="nav-staff-dashboard"
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : ""}`
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/staff/usage"
              data-testid="nav-staff-usage"
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : ""}`
              }
            >
              Usage
            </NavLink>
            <NavLink
              to="/staff/quick-usage"
              data-testid="nav-staff-quick-usage"
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : ""}`
              }
            >
              Quick Usage
            </NavLink>
            <NavLink
              to="/staff/quick-buy"
              data-testid="nav-staff-quick-buy"
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : ""}`
              }
            >
              Quick Buy
            </NavLink>
            {isAdmin && (
              <NavLink
                to="/staff/admin"
                data-testid="nav-staff-admin"
                className={({ isActive }) =>
                  `${linkBase} ${isActive ? linkActive : ""}`
                }
              >
                Admin
              </NavLink>
            )}
            {isAdmin && (
              <NavLink
                to="/management"
                data-testid="nav-management"
                className={linkBase}
              >
                Operations
              </NavLink>
            )}
            <Link to="/" className={linkBase}>
              ← Site
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm text-ink">{user?.preferred_name || user?.full_name}</p>
              <p className="overline text-ink-soft">
                {user?.role}{!user?.active && user?.role !== "admin" ? " · pending" : ""}
              </p>
            </div>
            <button
              data-testid="staff-logout-btn"
              onClick={onLogout}
              className="inline-flex items-center gap-2 rounded-full px-4 py-2 border border-ink/30 hover:bg-ink hover:text-bone transition-all duration-300 text-xs uppercase tracking-[0.18em]"
            >
              <LogOut size={14} />
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1400px] px-6 md:px-10 py-10 md:py-14">
        {children}
      </main>
    </div>
  );
}
